module.exports = __webpack_public_path__ + "static/media/image2.021877f9.png";